import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage} from 'react-intl'
import {
    Box,
    Flex,
    Text,
    Stack,
    Link
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {useMultiStyleConfig, useBreakpointValue} from '@chakra-ui/react'

const COUNTRY_MAP = {
    GB: 'United Kingdom',
    US: 'United States',
    CA: 'Canada'
}

const ShippingAddress = ({
    shippingFirstName,
    shippingLastName,
    street,
    city,
    state,
    postalCode,
    country,
    shippingPhone,
    accountEmail
}) => {
    const styles = useMultiStyleConfig('OrderDetail')
    const getStreetAndApartment = (street) => {
        if (!street) return {}

        const match = street.match(/^(.*?)(Apartment|Apt|Flat|Suite|Unit)\s*(.*)$/i)

        if (match) {
            return {
                streetName: match[1].trim(),
                apartment: `${match[2]} ${match[3]}`.trim()
            }
        }

        return {streetName: street}
    }

    const {streetName, apartment} = getStreetAndApartment(street)

    return (
        <Box {...styles.shippingAddressMainContainer}>
            <Stack>
                <Text {...styles.shippingAddressHeading}>
                    <FormattedMessage
                        id="account_order_detail.label.shipping_address"
                        defaultMessage="Shipping Address"
                    />
                </Text>
            </Stack>
            <Stack gap={0}>
                <Text {...styles.shippingEmailText}>{accountEmail}</Text>
                {(shippingFirstName || shippingLastName) && (
                    <Text {...styles.shippingNameText}>
                        {[shippingFirstName, shippingLastName].filter(Boolean).join(' ')}
                    </Text>
                )}
                {(streetName || apartment || city || state || postalCode) && (
                    <Text {...styles.shippingNameText}>
                        {[streetName, apartment, city, state, postalCode]
                            .filter(Boolean)
                            .join(', ')}
                    </Text>
                )}
                {shippingPhone && <Text {...styles.shippingNameText}>{shippingPhone}</Text>}
            </Stack>
        </Box>
    )
}

ShippingAddress.propTypes = {
    shippingFirstName: PropTypes.string,
    shippingLastName: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    postalCode: PropTypes.string,
    country: PropTypes.string,
    shippingPhone: PropTypes.string
}

export const OrderShippingAddress = ({order}) => {
      const isPickupInStore = Boolean(order.bopisStoreNumber) && !order.shippingMethod
      if (isPickupInStore) {
          return null
      }
    return (
        <Box>
            <ShippingAddress
                {...order.shippingAddress}
                shippingFirstName={order.shippingFirstName}
                shippingLastName={order.shippingLastName}
                shippingPhone={order.shippingPhone}
                accountEmail={order.account.email}
            />
        </Box>
    )
}

OrderShippingAddress.propTypes = {
    order: PropTypes.shape({
        payment: PropTypes.array.isRequired,
        ShippingAddress: PropTypes.shape({
            shippingFirstName: PropTypes.string,
            shippingLastName: PropTypes.string,
            street: PropTypes.string,
            city: PropTypes.string,
            state: PropTypes.string,
            postalCode: PropTypes.string,
            country: PropTypes.string,
            shippingPhone: PropTypes.string
        })
    }).isRequired
}